export default {
  /*按钮*/
  bt:{
    search:"搜索",
    query:"查询",
    operation:"操作",
    add:"新增",
    edit:"修改",
    delete:"删除",
    down:"下载",
    export:"导出",
    upload:"上传"
  },
  public:{
    audit:"审核",
    noPass:"不通过",
    pass:"通过",
    notAudit:"未审核"
  },
  wealth:{
    queryComment: '查看评论',
    title:'标题',
    type:'类型',
    content:'内容',
    author:'作者',
    createTime:"发布时间",
    readRandomCount:'虚拟阅读数',
    readRealCount:'真实阅读数',
    readTotalCount:'总阅读数',
    commentCount:'评论数',
    supportRandomCount:'虚拟点赞数',
    supportRealCount:'真实点赞数',
    supportTotalCount:'总点赞数',
    nickName:"评论用户",
    commentTime:"评论时间",
    remark:"留言内容",
    commentStatus:"审核状态",
    copy:"复制",
    audit:"审核",
    noPass:"不通过",
    pass:"通过",
    phone:"手机号",
    addComment:"添加评论",
    commentTotalCount:"评论总数",
    auditPassCount:"已审核通过评论数",
    auditNotPassCount:"审核不通过评论数",
    notAuditCount:"未审批评论数",
    shortEssay:"短贴",
    longEssay:"长文",
    notAudit:"未审核"
  },
  topic:{
    notStart:"未开启",
    start:"已开启",
    over:"已结束",
    en_US:"英文",
    vi_VN:"越南文",
    titleName:"话题名称",
    startTime:"开始时间",
    endTime:"结束时间",
    topicAbstract:"话题摘要",
    lang:"语言",
    productCode:"行情配置(用#隔开)",
    voteView:"投票观点",
    supportCopy:"支持文案",
    supportCount:"运营支持人数",
    oppositionCopy:"反对文案",
    oppositionCount:"运营反对人数",
    topicDetail:"话题详情",
    title:"标题",
    topicStatus:"话题状态",
    supportCountReal:"实际支持人数",
    oppositionCountReal:"实际反对人数",
    commentCount:"评论数",
    viewMessage:"查看留言",
    batchAudit:"批量审核成功必须勾选一个",
    topicMessage:"话题留言",
    export:"导出",
    batchUpdate:"批量更新",
    support:"支持",
    oppose:"反对",
    topic:"话题",
    status:"状态",
    opType:"观点",
    customerNo:"账号",
    createTime:"发表时间",
    likeCount:"点赞数",
    commentContent:"评论内容",
    updateTime:"更新时间",
    top:"置顶",
    notTop:"取消置顶"
  },
  question:{
    addType:"新增一级类别",
    name:"课程类别",
    code:"编码",
    type:"类型",
    decide:"判断题",
    radio:"单选题",
    checkbox:"多选题",
    question:"题目",
    options:"选项",
    addOption:"新增选项",
    deleteOption:"删除选项",
    answer:"答案",
    parsing:"解析",
  }
}
